module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    staticStyle: {
      "padding": "5%",
      "margin": "5%",
      "border-style": "double"
    },
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Getting the Most Out of  "), _c('i', [_vm._v(" Knowing God Bible Study")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('span', {
    attrs: {
      "href": "#/pre3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("INTRODUCTION")]), _c('br'), _vm._v("\n      Looking for God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("SESSION ONE")]), _c('br'), _vm._v("\n      God Beyond Comparison"), _c('br'), _vm._v(" "), _c('i', [_vm._v("Isaiah 40:21-31")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("SESSION TWO")]), _c('br'), _vm._v("\n      God’s Unfailing Faithfulness"), _c('br'), _vm._v(" "), _c('i', [_vm._v("Psalm 107:1-32")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("SESSION THREE")]), _c('br'), _vm._v("\n      God: Father, Son, Spirit"), _c('br'), _vm._v(" "), _c('i', [_vm._v("John 14:1-11; 16:5-15")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("SESSION FOUR")]), _c('br'), _vm._v("\n      God’s Merciful Discipline"), _c('br'), _c('i', [_vm._v("Hebrews 12:1-13")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("SESSION FIVE")]), _c('br'), _vm._v("\n      God’s Ultimate Triumph"), _c('br'), _vm._v(" "), _c('i', [_vm._v("Romans 8:31-39")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("LEADING A SMALL GROUP")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("SUGGESTED RESOURCES")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("THE IVP SIGNATURE COLLECTION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("ALSO AVAILABLE FROM IVP")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("ABOUT THE AUTHOR")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("MORE TITLES FROM INTERVARSITY PRESS")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 60
// module chunks = 0